module.exports = __webpack_public_path__ + "img/pdf.c126c204.svg";